import api from './api';

/** Per-person, per-week capacity against planned hours. */
export const getWorkload = async ({ dateFrom, dateTo } = {}) => {
    const params = {};
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    const res = await api.get('/Planning/workload', { params });
    return res.data;
};
